import classNames from 'classnames';
import { DragEventHandler, useCallback, useRef, useState } from 'react';

import useStyles from './styles';
import { IUploadArea } from './types';

function UploadArea({ className, children, disabled, accept, multiple, onUpload }: IUploadArea) {
  const classes = useStyles();
  const fileInputRef = useRef<HTMLInputElement>();

  const [dragHovering, setDragHovering] = useState<boolean>(false);

  const onAreaClick = useCallback(() => {
    if (disabled) {
      return;
    }

    fileInputRef.current.click();
  }, [disabled]);

  const onAreaDrag: (hovering: boolean) => DragEventHandler<HTMLDivElement> = useCallback(
    (hovering) => (event) => {
      event.stopPropagation();
      event.preventDefault();

      if (disabled) {
        return;
      }

      setDragHovering(hovering);
    },
    [disabled],
  );

  const onInputUpload = useCallback(() => {
    onUpload(fileListToArray(fileInputRef.current.files), 'button');
  }, [onUpload]);

  const onDropUpload: DragEventHandler<HTMLDivElement> = useCallback(
    (event) => {
      event.stopPropagation();
      event.preventDefault();

      if (disabled) {
        return;
      }

      setDragHovering(false);
      onUpload(fileListToArray(event.dataTransfer.files), 'drag_and_drop');
    },
    [disabled, onUpload],
  );

  return (
    <div
      className={classNames(classes.root, { hovering: dragHovering }, className)}
      onDragOver={onAreaDrag(true)}
      onDragLeave={onAreaDrag(false)}
      onDrop={onDropUpload}
      onClick={onAreaClick}
    >
      <input
        className={classes.input}
        type="file"
        ref={fileInputRef}
        onChange={onInputUpload}
        accept={accept}
        multiple={multiple}
      />
      {children}
    </div>
  );
}

function fileListToArray(fileList: FileList) {
  const filesArray = [];
  for (let i = 0; i < fileList.length; i++) {
    filesArray.push(fileList[i]);
  }
  return filesArray;
}

export default UploadArea;
